<mat-card
  (click)="onClick()"
  [class.pointer]="link"
  [style.background-image]="'url(' + imageSrc + ')'"
>
  @if (title) {
    <mat-card-header
      [class.no-flex]="circleImgSrc && titlePosition === 'below'"
      [class.center]="circleImgSrc && titlePosition === 'after'"
    >
      @if (circleImgSrc) {
        <div
          mat-card-avatar
          class="circle"
          [style.background-image]="'url(' + circleImgSrc + ')'"
          [style.width]="circleSizePx"
          [style.height]="circleSizePx"
          [class.no-margin]="circleImgSrc && titlePosition === 'after'"
        ></div>
      }
      <mat-card-title
        [style.color]="titleColor"
        [class.no-padding]="circleImgSrc && titlePosition === 'below'"
        >{{ title.toUpperCase() }}</mat-card-title
      >
      <mat-card-subtitle
        [class.no-padding]="circleImgSrc && titlePosition === 'below'"
        >{{ subtitle }}</mat-card-subtitle
      >
    </mat-card-header>
  }
  <mat-card-content>
    <ng-content select=".card-content"></ng-content>
  </mat-card-content>
  <!--mat-card-actions>
    <ng-content select=".card-actions"></ng-content>
  </mat-card-actions-->
</mat-card>
